










import { Vue, Component } from 'vue-property-decorator';
import MantenedorTipoUbicacionBase from './MantenedorTipoUbicacionBase.vue';

@Component({ components: { MantenedorTipoUbicacionBase } })
export default class MantenedorTipoUbicacionPantalla extends Vue {}
